import { z } from 'zod'

export const MentalHealthTreatmentHistoryFormSchema = z
  .object({
    SEEN_MENTAL_HEALTH_PROFESSIONAL_IN_PAST: z.boolean(),
    CARE_DETAILS: z.string().min(1).optional(),
    HOSPITALIZED_FOR_MENTAL_HEALTH: z.boolean(),
    HOSPITALIZATION_DETAILS: z.string().min(1).optional(),
    HISTORY_OF_TRAUMA: z.union([z.literal('reports_no'), z.literal('reports_yes')]),
    TRAUMA_DETAILS: z.string().min(1).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.SEEN_MENTAL_HEALTH_PROFESSIONAL_IN_PAST && !data.CARE_DETAILS) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['CARE_DETAILS'],
        message: 'Care details are required if seen mental health professional in past',
      })
    }

    if (data.HOSPITALIZED_FOR_MENTAL_HEALTH && !data.HOSPITALIZATION_DETAILS) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['HOSPITALIZATION_DETAILS'],
        message: 'Hospitalization details are required if hospitalized for mental health',
      })
    }

    if (data.HISTORY_OF_TRAUMA === 'reports_yes' && !data.TRAUMA_DETAILS) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['TRAUMA_DETAILS'],
        message: 'Trauma details are required if patient reports history of trauma',
      })
    }
  })
